'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetError = undefined;
exports.default = reducer;

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var RESET_ERROR = 'classpass/error/RESET';

var resetError = exports.resetError = function resetError() {
  return { type: RESET_ERROR };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shouldThrowErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __SERVER__;
  var type = action.type,
      error = action.error;


  if (type === RESET_ERROR) {
    return null;
  } else if (error && type.indexOf('@@redux-form') === -1) {
    logger.error(error);

    if (!action.suppressGlobalErrorHandling) {
      if (shouldThrowErrors && !action.fromClientMiddleware) {
        throw error;
      }

      return {
        message: typeof error === 'string' ? error : error.message,
        details: error && error.details,
        code: error && error.code,
        httpStatus: error && error.httpStatus
      };
    }
  }

  return state;
}